import React from "react"
import { VerEnviosIzzaContextProvider } from "./context/VerEnviosIzzaContextProvider"
import { VerEnviosIzza } from "./VerEnviosIzza"

export function Index() {
    return (
        <VerEnviosIzzaContextProvider>
            <VerEnviosIzza />
        </VerEnviosIzzaContextProvider>
    )
}
